export default "__VITE_ASSET__2wCbw1Cx__"